import { List } from 'immutable';
import { forecastedDividendConstants } from '../constants';

export function forecasted_dividends(state = {}, action) {
  switch (action.type) {
    case forecastedDividendConstants.FORECASTED_DIVIDEND_LIST_LOADING:
      return {
        ...state,
        items: null,
        listLoading: true
      };
    case forecastedDividendConstants.FORECASTED_DIVIDEND_LIST_SUCCESS:
      return {
        ...state,
        items: List(action.response),
        listLoading: false
      };
    case forecastedDividendConstants.FORECASTED_DIVIDEND_LIST_FAILURE:
      return {
        ...state,
        listLoading: false,
        items: null,
        listError: action.error
      };
    case forecastedDividendConstants.FORECASTED_DIVIDEND_CREATE_LOADING:
      return {
        ...state,
        createLoading: true
      };
    case forecastedDividendConstants.FORECASTED_DIVIDEND_CREATE_SUCCESS: {
      const items = state.items ? state.items : List();
      return {
        ...state,
        items: items.push(action.response),
        createLoading: false,
        createError: null
      };
    }
    case forecastedDividendConstants.FORECASTED_DIVIDEND_CREATE_FAILURE:
      return {
        ...state,
        createLoading: false,
        createError: action.error
      };

    case forecastedDividendConstants.FORECASTED_DIVIDEND_EDIT_LOADING:
      return {
        ...state,
        editLoading: true
      };
    case forecastedDividendConstants.FORECASTED_DIVIDEND_EDIT_SUCCESS: {
      if (!state.items) {
        return state;
      }

      const forecastedDividendIndex = state.items.findIndex(val => val.id == action.response.id);

      if (forecastedDividendIndex == -1) {
        return state;
      }

      return {
        ...state,
        items: state.items.set(forecastedDividendIndex, action.response),
        editLoading: false,
        editError: null
      };
    }
    case forecastedDividendConstants.FORECASTED_DIVIDEND_EDIT_FAILURE:
      return {
        ...state,
        editLoading: false,
        editError: action.error
      };

    case forecastedDividendConstants.FORECASTED_DIVIDEND_DELETE_LOADING:
      return {
        ...state,
        deleteLoading: true
      };
    case forecastedDividendConstants.FORECASTED_DIVIDEND_DELETE_SUCCESS: {
      const { forecastedDividendId } = action;

      if (!state.items) {
        return state;
      }

      const forecastedDividendIndex = state.items.findIndex(val => val.id == forecastedDividendId);

      if (forecastedDividendIndex == -1) {
        return state;
      }

      return {
        ...state,
        items: state.items.delete(forecastedDividendIndex),
        deleteLoading: false,
        deleteError: null
      };
    }
    case forecastedDividendConstants.FORECASTED_DIVIDEND_DELETE_FAILURE:
      return {
        ...state,
        deleteLoading: false,
        deleteError: action.error
      };
    case forecastedDividendConstants.FORECASTED_DIVIDEND_ERROR_RELOAD:
      return {
        ...state,
        createError: null,
        editError: null
      };

    default:
      return state;
  }
}
